<template>
  <div id="not-found-page">
    <HeaderComponentVue />
    <div class="desc">Not Found page</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HeaderComponentVue from "@/common/components/HeaderComponent.vue";

export default defineComponent({
  setup() {
    return {};
  },
  data() {
    return {
      title: "",
    };
  },
  components: { HeaderComponentVue },
  methods: {
    helloWorld() {
      console.log("helloWorld!");
    },
  },
  created() {
    //
  },
});
</script>

<style lang="scss" scoped></style>
